import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetTeams, DeleteTeam } from "../../api's/settings.js";
import { Flex, Table, message } from "antd";
import { CustomParagraph, CustomTitle, AddItemButton } from "../../components";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext.js";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit-gray-icon.svg";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import TeamForm from "./TeamForm.jsx";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import { useSelector,useDispatch } from "react-redux";
import { getPermissions } from "../../common/helper/getPermissions.js";
import { fetchTeamsDDL } from "../../reudx-toolkit/slice/teamsSlice.js";
import { get } from "firebase/database";
const SettingsTeams = ({ title }) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const [teamsList, setTeamsList] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentTeam, setCurrentTeam] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const dispatch = useDispatch();
  const main_menu = useSelector((state) => state.menu.items);
    const TeamsPermissions = getPermissions(main_menu, "Settings", "Teams");

console.log('team list' , teamsList)
console.log('selectedTeam list' , selectedTeam)

  const staticTeamsData = [
    {
      id: 1,
      name: "Internal medicine",
      transport_providers: 5,
      products: 9,
      sensors: 4,
      locations: 54,
      users: 10,
      shipments: 256,
      color: "#30D5C8",
    },
    {
      id: 2,
      name: "Hospital",
      transport_providers: 2,
      products: 23,
      sensors: 3,
      locations: 12,
      users: 23,
      shipments: 65,
      color: "#D2A3F0",
    },
    {
      id: 3,
      name: "Oncology",
      transport_providers: 17,
      products: 17,
      sensors: 2,
      locations: 5,
      users: 12,
      shipments: 32,
      color: "#F19898",
    },
    {
      id: 4,
      name: "Vaccines",
      transport_providers: 2,
      products: 9,
      sensors: 1,
      locations: 2,
      users: 11,
      shipments: 33,
      color: "#F4D35E",
    },
    {
      id: 5,
      name: "Specialty pharma",
      transport_providers: 8,
      products: 21,
      sensors: 3,
      locations: 12,
      users: 5,
      shipments: 89,
      color: "#93E9BE",
    },
  ];

  

  const fetchTeams = () => {
    showSpin();
    GetTeams(token)
      .then((res) => {
        if (res?.data?.data?.is_success && Array.isArray(res.data.data.data)) {
          setTeamsList(res.data.data.data);
        } 
        // else {
        //   message.error(res?.data?.data?.message || "Failed to fetch teams");
        //   setTeamsList(staticTeamsData);
        // }
      })
      .catch((error) => {
        console.error("Error fetching teams:", error);
        // setTeamsList(staticTeamsData);
        unauthorize(error);
      })
      .finally(() => hideSpin());
  };

  useEffect(() => {
   getAllTeams();
  }, [token]);


  const getAllTeams = ()=>{
    dispatch(fetchTeamsDDL(token))
    fetchTeams();
  }

  const handleDeleteClick = (team) => {
    setSelectedTeam(team);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (!selectedTeam) return;
    showSpin();
    DeleteTeam(token, selectedTeam.id)
      .then((res) => {
        if (res?.data?.data?.is_success) {
          message.success(res.data.data.message);
          setTeamsList((prevList) =>
            prevList.filter((team) => team.id !== selectedTeam.id)
          );
          getAllTeams();
        } else {
          message.error(res.data.data.message);
        }
      })
      .catch((error) => {
        unauthorize(error);
        message.error("Failed to delete team")})
      .finally(() => {
        hideSpin();
        setDeleteModalVisible(false);
      });
  };

  const handleEdit = (record) => {
    setCurrentTeam(record);
    setDrawerOpen(true);
  };

  const handleAddTeam = () => {
    setCurrentTeam(null);
    setDrawerOpen(true);
  };

  const unauthorize = (error) => {
    if (error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "min-width-name",
      render: (text, record) => (
        <>
        <Flex align="center" gap="8px">
          <span
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: record.color,
              borderRadius: "50%",
              display: "inline-block",
            }}
          ></span>
          <CustomParagraph
            text={text}
            fontSize={14}
            fontWeight={600}
            color="#000"
            marginBottom={0}
          />
        </Flex>
        </>
      ),
    },
    {
      title: "Transport providers",
      dataIndex: "transport_providers",
      key: "transport_providers",
      width: 150,
      render: (value) => (value ?? 0),
    },
    { title: "Products", dataIndex: "products", key: "products", width: 150 , render: (value) => (value ?? 0) },
    { title: "Sensors", dataIndex: "sensors", key: "sensors", width: 150, render: (value) => (value ?? 0), },
    {
      title: "Locations",
      dataIndex: "locations",
      key: "locations",
      width: 150,
      render: (value) => (value ?? 0),
    },
    { title: "Users", dataIndex: "users", key: "users", width: 150, render: (value) => (value ?? 0), },
    {
      title: "Shipments",
      dataIndex: "shipments",
      key: "shipments",
      width: 150,
      render: (value) => (value ?? 0),
    },
    {
      title: "Notifications",
      dataIndex: "notifications",
      key: "notifications",
      width: 150,
      render: (value) => (value ?? 0),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
          <Flex
            justify="center"
            align="center"
            style={{
              width: "42px",
              gap: "30px",
              height: "32px",
              cursor: "pointer",
            }}
          >
          {record?.permissions?.is_update &&
            <img src={editIcon} alt="Edit" title="Edit" onClick={() => handleEdit(record)} />
          }
         {record?.permissions?.is_delete &&
           <img src={deleteIcon} alt="Delete" title="Delete" onClick={() => handleDeleteClick(record)}/>
         }
          </Flex>
      ),
    },
  ];

  return (
    <>
    <div className="settings-content-wrapper">
      <CustomTitle
        text={`${title} (${teamsList.length})`}
        fontSize={20}
        fontWeight="700"
        lineHeight="32px"
        color="#000"
        marginBottom={0}
      />

      {/* <Flex vertical={true} gap={32}> */}
        <Table
          columns={columns}
          dataSource={teamsList}
          pagination={false}
          className="settings-table"
          rowHoverable={false}
        />
        {TeamsPermissions?.is_create &&
        <AddItemButton
          fontSize="12px"
          fontWeight="600"
          text={"Add team"}
          onClick={handleAddTeam}
          marginTop="0px"
        />}
          </div>
      {/* </Flex> */}
          {drawerOpen && (
      <CommonDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <TeamForm
          teamData={currentTeam}
          onClose={() => setDrawerOpen(false)}
          refreshTeams={getAllTeams}
        />
      </CommonDrawer>
)}
      <CustomDeleteModal
        visible={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onConfirm={handleConfirmDelete}
        title={selectedTeam?.is_connected_with_anything ? "Action needed"  : "Remove Team"}
        message={selectedTeam?.is_connected_with_anything ? "Unable to delete team. Please remove all associated transport providers, products, sensors, locations, and users before trying again." :"All data and users assigned to this team will be removed."}
        cancelText="Cancel"
        confirmText={selectedTeam?.is_connected_with_anything ? '' : "Remove"}
        confirmColor="#DE1135"
      />
      <CustomDeleteModal
        visible={false}
        onClose={() => setDeleteModalVisible(false)}
        title="Action needed"
        message="Unable to delete team. Please remove all associated transport providers, products, sensors, locations, and users before trying again."
        cancelText="Cancel"
      />
    </>
  );
};

export default SettingsTeams;
